// 用户

import UltMeta, { Meta } from "./UltMeta/index";

class Type extends UltMeta {
    NORMAL = new Meta(1, "普通用户");
    ADMIN = new Meta(2, "管理员");
}

export const TYPE = new Type();

class State extends UltMeta {
    ACTIVE = new Meta(1, "启用中");
    SUSPEND = new Meta(2, "停用中");
}

export const STATE = new State();

/**
 * 用户状态
 */
class UserState extends UltMeta {
    ENABLE = new Meta(1, "已启用");
    DISABLE = new Meta(0, "已禁用");
    CANCELLING_IN_PROGRESS = new Meta(2, "注销中");
    CANCELLED = new Meta(3, "已注销");
}

export const USER_STATE = new UserState();

class Origin extends UltMeta {
    ZHIHAO = new Meta("ZHIHAO", "志豪集团企业人员");
    ENTERPRISE = new Meta("ENTERPRISE", "企业定制用户");
}

export const ORIGIN = new Origin();

/** 受邀状态 */
class Invitation extends UltMeta {
    NOT_CONFIRMED = new Meta(1, "未确认");
    CONFIRMED = new Meta(2, "已确认");
    REJECTED = new Meta(3, "已拒绝");
}
/** 受邀状态 */
export const INVITATION = new Invitation();


/**
 * 用户自定义列类型
 */
class businessType extends UltMeta {
    PRODUCT = new Meta(1, "商品分析列表");
    FUNCTION = new Meta(2, "功能分析列表");
}
export const BUSSINESS_TYPE = new businessType();
